(() => {
  const carousels = [
    {
      section: '[id$="__featured_collection_wRd3Kd"]',
      slider: '.t4s_box_pr_slider.flickityt4s',
      type: 'products',
      thumb: 44
    },
    {
      section: '[id$="__testimonials_hX9BpT"]',
      slider: '.t4s-quotes-des-1.flickityt4s',
      type: 'testimonials',
      thumb: 31
    }
  ];

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const installRail = (section, config, attempt = 0) => {
    const slider = section.querySelector(config.slider);
    const flickity = slider && slider.flickityt4s && slider.flickityt4s.flkty;

    if (!flickity) {
      if (attempt < 30) window.setTimeout(() => installRail(section, config, attempt + 1), 100);
      return;
    }

    flickity.options.draggable = true;
    if (typeof flickity.updateDraggable === 'function') flickity.updateDraggable();
    slider.classList.add('zayor-drag-enabled');

    if (section.dataset.zayorProgressReady === 'true') return;

    const getCount = () => Math.max(flickity.slides.length, 1);
    if (getCount() < 2) return;

    const sectionInner = section.querySelector('.t4s-section-inner');
    const rail = document.createElement('div');
    const fill = document.createElement('span');
    const heading = section.querySelector('.t4s-section-title');

    rail.className = 'zayor-carousel-progress';
    rail.dataset.zayorProgressType = config.type;
    rail.setAttribute('role', 'slider');
    rail.setAttribute('tabindex', '0');
    rail.setAttribute('aria-valuemin', '1');
    rail.setAttribute('aria-label', heading ? heading.textContent.trim() : '');
    fill.className = 'zayor-carousel-progress__fill';
    rail.appendChild(fill);
    sectionInner.appendChild(rail);
    sectionInner.classList.add('zayor-has-interactive-progress');
    section.dataset.zayorProgressReady = 'true';

    const select = (index) => {
      flickity.select(clamp(index, 0, getCount() - 1));
    };

    const sync = () => {
      const count = getCount();
      const index = clamp(flickity.selectedIndex || 0, 0, count - 1);
      const travel = 100 - config.thumb;
      const left = count > 1 ? (index / (count - 1)) * travel : 0;

      fill.style.width = `${config.thumb}%`;
      fill.style.left = `${left}%`;
      rail.setAttribute('aria-valuemax', String(count));
      rail.setAttribute('aria-valuenow', String(index + 1));
    };

    const selectFromPointer = (event) => {
      const bounds = rail.getBoundingClientRect();
      const ratio = clamp((event.clientX - bounds.left) / bounds.width, 0, 1);
      select(Math.round(ratio * (getCount() - 1)));
    };

    let isDragging = false;
    rail.addEventListener('pointerdown', (event) => {
      isDragging = true;
      rail.setPointerCapture(event.pointerId);
      selectFromPointer(event);
      event.preventDefault();
    });
    rail.addEventListener('pointermove', (event) => {
      if (isDragging) selectFromPointer(event);
    });
    rail.addEventListener('pointerup', () => {
      isDragging = false;
    });
    rail.addEventListener('pointercancel', () => {
      isDragging = false;
    });
    rail.addEventListener('keydown', (event) => {
      const lastIndex = getCount() - 1;
      if (event.key === 'ArrowRight') select((flickity.selectedIndex || 0) + 1);
      if (event.key === 'ArrowLeft') select((flickity.selectedIndex || 0) - 1);
      if (event.key === 'Home') select(0);
      if (event.key === 'End') select(lastIndex);
      if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) event.preventDefault();
    });

    flickity.on('select', sync);
    flickity.on('resize', sync);
    sync();
  };

  const installProductUgc = (root) => {
    const track = root.querySelector('[data-zayor-ugc-track]');
    const cards = Array.from(root.querySelectorAll('[data-zayor-ugc-card]'));

    cards.forEach((card) => {
      if (card.dataset.zayorUgcReady === 'true') return;

      const video = card.querySelector('video');
      const trigger = card.querySelector('[data-zayor-ugc-play]');
      if (!video || !trigger) return;

      card.dataset.zayorUgcReady = 'true';
      trigger.addEventListener('click', () => {
        card.classList.add('is-playing');
        video.controls = true;
        const playRequest = video.play();
        if (playRequest && typeof playRequest.catch === 'function') {
          playRequest.catch(() => card.classList.remove('is-playing'));
        }
      });
      video.addEventListener('ended', () => {
        video.controls = false;
        video.currentTime = 0;
        card.classList.remove('is-playing');
      });
    });

    if (!track || cards.length === 0 || root.dataset.zayorCarouselReady === 'true') return;

    const previous = root.querySelector('[data-zayor-ugc-prev]');
    const next = root.querySelector('[data-zayor-ugc-next]');
    const current = root.querySelector('[data-zayor-ugc-current]');
    const total = root.querySelector('[data-zayor-ugc-total]');
    const progress = root.querySelector('[data-zayor-ugc-progress]');
    const formatIndex = (value) => String(value).padStart(2, '0');
    const getGap = () => parseFloat(window.getComputedStyle(track).columnGap) || 0;
    const getStep = () => (cards[0] ? cards[0].getBoundingClientRect().width + getGap() : track.clientWidth);
    const getMaxScroll = () => Math.max(track.scrollWidth - track.clientWidth, 0);
    const getIndex = () => clamp(Math.round(track.scrollLeft / Math.max(getStep(), 1)), 0, cards.length - 1);

    const sync = () => {
      const maxScroll = getMaxScroll();
      const index = getIndex();
      const visibleRatio = track.scrollWidth > 0 ? clamp(track.clientWidth / track.scrollWidth, 0, 1) : 1;
      const travel = 100 - visibleRatio * 100;
      const progressLeft = maxScroll > 0 ? (track.scrollLeft / maxScroll) * travel : 0;

      if (current) current.textContent = formatIndex(index + 1);
      if (total) total.textContent = formatIndex(cards.length);
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
      if (progress) {
        progress.style.width = `${visibleRatio * 100}%`;
        progress.style.left = `${progressLeft}%`;
      }

      root.classList.toggle('is-static', maxScroll <= 2);
    };

    const moveByCard = (direction) => {
      track.scrollBy({ left: getStep() * direction, behavior: 'smooth' });
    };

    if (previous) previous.addEventListener('click', () => moveByCard(-1));
    if (next) next.addEventListener('click', () => moveByCard(1));
    track.addEventListener('scroll', sync, { passive: true });
    track.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') moveByCard(1);
      if (event.key === 'ArrowLeft') moveByCard(-1);
      if (event.key === 'Home') track.scrollTo({ left: 0, behavior: 'smooth' });
      if (event.key === 'End') track.scrollTo({ left: getMaxScroll(), behavior: 'smooth' });
      if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) event.preventDefault();
    });

    let isDragging = false;
    let dragStartX = 0;
    let dragStartScroll = 0;

    track.addEventListener('pointerdown', (event) => {
      /*
       * Le glissement peut commencer sur l'affiche de la vidéo.
       * Une vidéo déjà en lecture conserve en revanche ses contrôles natifs.
       */
      if (
        event.button !== 0 ||
        event.target.closest('button, a') ||
        event.target.closest('.zayor-product-ugc__card.is-playing')
      ) {
        return;
      }
      isDragging = true;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    });

    track.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
      event.preventDefault();
    });

    const endDrag = () => {
      isDragging = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    window.addEventListener('resize', sync);

    root.dataset.zayorCarouselReady = 'true';
    sync();
  };

  const initialise = () => {
    carousels.forEach((config) => {
      document.querySelectorAll(config.section).forEach((section) => installRail(section, config));
    });
    document.querySelectorAll('.template-product [data-zayor-product-ugc]').forEach(installProductUgc);
  };

  document.addEventListener('DOMContentLoaded', () => window.setTimeout(initialise, 200));
  window.addEventListener('load', initialise);
  document.addEventListener('shopify:section:load', () => window.setTimeout(initialise, 100));
})();
